/**
 * 功能描述： 资源目录树处理工具 <br>
 * 〈〉
 * @Author CHU
 * @Date 13:42 2021/2/22
 **/

/**
 * 功能描述： 获取选择的名字 <br>
 * 〈〉
 * @Param 资源目录树 | 资源目录id
 * @Return 资源目录名称
 * @Author CHU
 * @Date 13:43 2021/2/22
 **/
export function getSelectName(items, id) {
  let name = null;

  if (!id) return name;

  for (let i = 0; i < items.length; i++) {
    let item = items[i];
    if (item.id === id) {
      name = item.name;
      break;
    } else {
      if (!item.leaf) {
        // 判断是否有子节点被选择
        name = getSelectName(item.jtypes, id);
        if (null != name) break;
      }
    }
  }

  return name;
}

/**
 * 功能描述：通过id数组获取资料类目全路径名称 <br>
 * 〈〉
 * @Param optionsCatalog: 完整的资源目录树, catalog：需要获取的资源目录id数组, index：当前数组索引
 * @Return
 * @Author CHU
 * @Date 11:27 2021/5/18
 **/
export function getTypeNames(optionsCatalog, catalog, index) {
  let names = "";
  let subOptionsCatalog = [];
  optionsCatalog.forEach(item => {
    if (item.id == catalog[index]) {
      names = item.name;
      subOptionsCatalog = item.jtypes;
    }
  });

  if (0 != subOptionsCatalog.length && index < catalog.length) {
    return names + "_" + getTypeNames(subOptionsCatalog, catalog, index + 1);
  } else {
    return names;
  }
}

/**
 * 功能描述：通过id获取资料类目全路径名称 <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 11:38 2021/5/18
 **/
export function getTypeNamesById(optionsCatalog, catalog) {
  let names = "";
  for (let i = 0; i < optionsCatalog.length; i++) {
    let item = optionsCatalog[i];
    // console.log(item.id, "-", item.name, "-",catalog);
    if (item.id == catalog) {
      names = item.name;
      break;
    }

    names = getTypeNamesById(item.jtypes, catalog);
    if ("" != names) {
      return item.name + "_" + names;
    }
  }

  return names;
}
